import { CompatRouter } from '@im-frontend/utils/CompatRouter';
import Sparse from 'components/layouts/Sparse';
import Splash from 'components/layouts/Splash';
import NotFound from 'components/shared/NotFound';
import Dashboard from 'components/views/Dashboard';
import Invitations from 'components/views/Invitations';
import Password from 'components/views/Password';
import Accounts from 'components/views/Principals/Show';
import Session from 'components/views/Session';
import ZenHall from 'components/views/ZenHall';
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom-v5-compat';

import './App.scss';

/// Reduce mental burden by letting us navigate to back end routes via React router.
/// Renders nothing: it only leaves the app for the given back end path.
function ExternalRedirect({ path }: { path: string }) {
  useEffect(() => {
    if (window.Office) {
      window.location.href = path;
    } else {
      window.location.replace(path);
    }
  }, [path]);

  return null;
}

/// Generic 404 screen.
function RouteNotFound() {
  return (
    <Sparse>
      <NotFound />
    </Sparse>
  );
}

/**
 * The whole app + the one-and-only central router.
 *
 * Note that the `Splash` layout wraps every route. An alternative approach
 * would be to let each route define its own page-layout and only do routing
 * in the app. (There is a `Sparse` layout available which does not have the
 * IM logo, for instance.)
 *
 * If we ever need different layouts for different routes, please remove the
 * top-level layout here and delegate layout decision to routes instead.
 */
function App() {
  return (
    <div id="app">
      <BrowserRouter basename="/">
        <CompatRouter>
          <Splash>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/appf" element={<ZenHall />} />
              <Route path="/invitations/*" element={<Invitations />} />
              <Route path="/session/*" element={<Session />} />
              <Route path="/password/*" element={<Password />} />
              <Route path="/principals/:id" element={<Accounts />} />
              <Route
                path="/auth/okta"
                element={<ExternalRedirect path="/auth/okta" />}
              />
              <Route
                path="/oauth2/continue"
                element={<ExternalRedirect path="/oauth2/continue" />}
              />
              <Route path="*" element={<RouteNotFound />} />
            </Routes>
          </Splash>
        </CompatRouter>
      </BrowserRouter>
    </div>
  );
}

export default App;
